module.exports = __webpack_public_path__ + "img/order-slides.cfe81976.svg";